import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Link from '@/components/redesign/JourneyLink';
import { journeyKind, journeyParent, hasGuideBreadcrumbs } from '@/components/redesign/journeyNavigation';
export default function PublicBackLink() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const path = pathname.toLowerCase().replace(/\/$/, '') || '/';
  if (!journeyKind(path) || hasGuideBreadcrumbs(path) || ['/', '/en', '/forside', '/home'].includes(path)) return null;
  const en = path.startsWith('/en/') || path === '/about-en';
  const hasPrevious = Number(window.history.state?.idx) > 0;
  return <nav className="ee-site ee-container py-4 text-ee-ink" aria-label={en ? 'Return navigation' : 'Tilbage til tidligere side'}>
    <Link className="ee-text-link inline-flex items-center gap-2 text-sm" to={journeyParent(path)} onClick={event => {
      if (hasPrevious && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) { event.preventDefault(); navigate(-1); }
    }}><ArrowLeft size={15} />{hasPrevious ? (en ? 'Back to previous page' : 'Tilbage til forrige side') : en ? 'Back to overview' : 'Tilbage til oversigten'}</Link>
  </nav>;
}